<script setup lang="ts">

import { onMounted } from 'vue';
import { usePresentation } from '@presentation/Types';

const presentation = usePresentation();
onMounted( () => presentation.registerTrigger( 3 ) );

</script>

<template>

    <Page>

        <div class="w-full grid grid-cols-1 lg:grid-cols-9 items-center gap-12 grow">
            
            <div class="w-full mx-auto col-span-1 lg:col-span-4 flex items-center justify-center max-w-[70%]">
                
                <Image src="/Marketplace/marketplace-triangle-phone-1.png" 
                    class="absolute transition-all duration-500 ease"
                    :class="presentation.currentTrigger >= 2 ? 'opacity-0' : 'opacity-100'" 
                />

                <Image src="/Marketplace/marketplace-triangle-nodes.png" 
                    class="absolute scale-125 transition-opacity duration-500 ease"
                />

                <Image src="/Marketplace/marketplace-triangle-arrows-1.png" 
                       class="absolute scale-125 transition-opacity duration-500 ease"
                       :class="presentation.currentTrigger < 0 ? 'opacity-0' : 'opacity-100'" 
                />

                <Image src="/Marketplace/marketplace-triangle-arrows-2.png" 
                       class="absolute scale-125 transition-opacity duration-500 ease"
                       :class="presentation.currentTrigger < 1 ? 'opacity-0' : 'opacity-100'" 
                />

                <Image src="Marketplace/marketplace-triangle-arrows-3.png" 
                       class="absolute scale-125 transition-opacity duration-500 ease"
                       :class="presentation.currentTrigger < 2 ? 'opacity-0' : 'opacity-100'" 
                />

                <Image src="/Marketplace/marketplace-triangle-phone-2.png" 
                    class="absolute transition-all duration-500 ease scale-[140%]"
                    :class="presentation.currentTrigger < 2 ? 'opacity-0' : 'opacity-100 pulse'" 
                />

            </div>

            <div class="col-span-1 lg:col-span-5 flex flex-col justify-start items-start w-full
                        text-base lg:text-lg xl:text-xl 2xl:text-2xl mx-auto pr-16">
                <h2 class="my-4 font-semibold">The Carbucks Marketplace</h2>
                <p class="text-white/80">
                    Unique to the Australian Auto industry, the Carbucks App connects the customer to the dealer and a unique marketplace of automotive and lifestyle offers
                </p>
                <ul class="mt-3 list-disc font-semibold leading-[2.4rem]">
                    <li v-if="presentation.currentTrigger >= 0" class="pl-2 ml-4 transition-colors duration-300 leading-[1.8rem] mb-2 2xl:mb-3" :class="presentation.currentTrigger == 0 ? 'text-emerald-400' : 'text-white/60'">Every customer leaves with the Carbucks App installed on their phone</li>
                    <li v-if="presentation.currentTrigger >= 1" class="pl-2 ml-4 transition-colors duration-300 leading-[1.8rem] mb-2 2xl:mb-3" :class="presentation.currentTrigger == 1 ? 'text-emerald-400' : 'text-white/60'">With every purchase money goes into their account</li>
                    <li v-if="presentation.currentTrigger >= 2" class="pl-2 ml-4 transition-colors duration-300 leading-[1.8rem] mb-2 2xl:mb-3" :class="presentation.currentTrigger == 2 ? 'text-emerald-400' : 'text-white/60'">And the Dealer gets paid for every transaction</li>
                </ul>
            </div>
        </div>

    </Page>

</template>

<style scoped lang="scss">

@keyframes pulse-keyframes 
{
    0% {
        transform: scale(1.0) rotateZ( -2deg);
    }
    100% {
        transform: scale(1.1) rotateZ( 2deg);
    }
}

.pulse 
{
    animation: pulse-keyframes 1s infinite alternate;
    -webkit-animation: pulse-keyframes 1s infinite alternate;
}

</style>